<template>
    <user-dashboard-layout>

        <div class="keywords-block">
            <div class="keywords-content">
                <div class="keywords-top">
                    <h4 class="keywords-top__title">Tracked Keywords</h4>
                    <Button @click="showModal = !showModal">
                        Add keyword
                    </Button>
                </div>

                <Modal
                    :show="showModal"
                    @close="showModal = false"
                    title="Add Keyword"
                >
                    <div class="modal-add-keyword">
                        <div class="modal-add-keyword__line">
                            <label for="" class="modal-add-keyword__label"
                                >Platform</label
                            >
                            <Multiselect
                                v-model="selectedPlatform"
                                :options="[
                                    'upwork',
                                    'freelance.habr.com',
                                    'freelance.ru',
                                    'fl.ru'
                                ]"
                                :searchable="false"
                                :show-labels="false"
                                placeholder="Select platform"
                                class="modal-add-keyword__select"
                            ></Multiselect>
                        </div>
                        <div class="modal-keyword">
                          <input
                            v-model="keyword"
                            placeholder="Keyword"
                            class="keyword-input"
                          >
                        </div>
                    </div>
                    <template #footer>
                        <div class="modal-add-keyword-footer">
                            <Button
                                @click="showModal = false"
                                :border="true"
                                class="modal-add-keyword-footer__btn modal-add-keyword-footer__btn_close"
                                >Close</Button
                            >
                            <Button
                                @click.stop="savePlatform"
                                class="modal-add-keyword-footer__btn"
                                >Save</Button
                            >
                        </div>
                    </template>
                </Modal>

                <div class="table-wrapper" :class="isTableScrollable">
                    <div class="scrollable" @scroll="handleScroll">
                        <table id="secondTable">
                            <thead>
                                <tr>
                                    <th
                                        v-for="(item, index) in headers"
                                        :key="index"
                                    >
                                        {{ item.text }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="keyword in keywords"
                                    :key="keyword.id"
                                >
                                    <td>{{ keyword.text }}</td>
                                    <td>
                                        <div
                                            v-if="
                                                keyword.proposal_send_periods
                                                    .length
                                            "
                                        >
                                            <span
                                                v-for="item in keyword.proposal_send_periods"
                                                :key="item.id"
                                                class="table-time-text"
                                                >{{ item.weekday }}:
                                                <strong
                                                    >{{
                                                        item.start_at.substring(
                                                            0,
                                                            5
                                                        )
                                                    }}
                                                    -
                                                    {{
                                                        item.end_at.substring(
                                                            0,
                                                            5
                                                        )
                                                    }}</strong
                                                ></span
                                            >
                                        </div>
                                        <span v-else>periods doesn't have</span>
                                    </td>
                                    <td>{{ keyword.platform }}</td>
                                    <td>
                                        <ToggleSwitch
                                            v-model="keyword.is_active"
                                            @update="
                                                updateKeywordStatus(
                                                    keyword,
                                                    keyword.is_active
                                                )
                                            "
                                        />
                                    </td>
                                    <td class="table-actions">
                                        <router-link
                                            :to="
                                                `/dashboard/keywords/edit/${keyword.id}`
                                            "
                                        >
                                            <img
                                                class="table-actions__img"
                                                src="@/assets/images/icons/edit.svg"
                                                alt="edit"
                                            />
                                        </router-link>
                                        <span @click.stop="removeItem(keyword)">
                                            <img
                                                class="table-actions__img"
                                                src="@/assets/images/icons/close-red.svg"
                                                alt="delete"
                                            />
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </user-dashboard-layout>
</template>

<script>
import UserDashboardLayout from "../../../layouts/UserDashboardLayout.vue";
import ToggleSwitch from "@/components/ui/ToggleSwitch.vue";
import Button from "@/components/ui/Button.vue";
import Multiselect from "vue-multiselect";
import Modal from "@/components/Modal.vue";


export default {
    name: "Index",
    components: {
        UserDashboardLayout,
        ToggleSwitch,
        Button,
        Multiselect,
        Modal
    },
    metaInfo() {
        return {
            title: "Keywords"
        };
    },
    data() {
        return {
            showModal: false,
            selectedPlatform: null,

            isScrolled: false,
            isScrollableRight: false,
            test: false,

            prevScrollLeft: 0,
            myValue: "",
            myOptions: ["op1", "op2", "op3"],

            keyword: "",
            keywords: [],
            headers: [
                {
                    text: "Text",
                    align: "start",
                    sortable: false,
                    value: "text"
                },
                {
                    text: "Time",
                    align: "start",
                    sortable: false,
                    value: "proposal_send_periods"
                },
                {
                    text: "Platform",
                    align: "start",
                    sortable: false
                },
                {
                    text: "Active",
                    sortable: false,
                    value: "switch"
                },
                {
                    text: "action",
                    sortable: false,
                    align: "end",
                    value: "action"
                }
            ]
        };
    },
    computed: {
        isTableScrollable() {
            return {
                "is-scrolled": this.isScrolled,
                "is-scrollable":
                    this.isScrollableRight || this.isScrolled === false
            };
        }
    },
    methods: {
        savePlatform() {
            if (this.selectedPlatform === "upwork") {
                this.showModal = false;
                this.$router.push({
                    name: "dashboard.keywords.create",
                    query: { platform: "upwork", keyword: this.keyword }
                });
            } else {
                this.showModal = false;
                this.$router.push({
                    name: "dashboard.keywords.create",
                    query: { platform: this.selectedPlatform, keyword: this.keyword }
                });
            }

            // this.showModal = false;
        },
        save() {
            this.$router.push({ name: "dashboard.keywords.create" });
        },
        removeItem(item) {
            window.axios.delete("/api/keywords/" + item.id).then(res => {
                if (res.status === 200) {
                    this.keywords = res.data.keywords;
                }
            });
        },
        routeTo(e) {
            this.$router.push({
                name: "dashboard.keywords.edit",
                params: { id: e.id }
            });
        },
        updateKeywordStatus(keyword, value) {
            window.axios.put("api/keywords/" + keyword.id, {
                is_active: value
            });
        },
        handleScroll(event) {
            const container = event.target;
            const scrollLeft = container.scrollLeft;
            const isScrollableRight =
                container.scrollWidth > container.clientWidth + scrollLeft;

            if (scrollLeft > this.prevScrollLeft) {
                this.isScrolled = true;
            } else if (scrollLeft === 0) {
                this.isScrolled = false;
            }

            this.isScrollableRight = isScrollableRight;
            this.prevScrollLeft = scrollLeft;
        }
    },
    mounted() {
        window.axios.get("/api/keywords").then(res => {
            this.keywords = res.data.keywords;
        });
    }
};
</script>

<style lang="scss" scoped>
.container-wrappper {
    // width: 450px;

    .select2-container {
        width: 100% !important;
    }
}

p {
    margin-bottom: 0 !important;
}

.container {
    height: 100%;
    background: #f5f5f5;
}

.tasks-list {
    cursor: pointer;

    &:nth-child(n + 2) {
        border-top: 1px solid rgba($color: #000000, $alpha: 0.2);
    }
}

.item-done {
    text-decoration: line-through;
}

.keywords-block {
    padding: 32px 0 100px;
}

.keywords-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &:not(:last-child) {
        margin-bottom: 15px;
    }
    &__title {
        font-size: 15px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        color: #000;
    }
}

.table-wrapper {
    position: relative;
    z-index: 1;
    width: 100%;
    display: flex;
    &.is-scrolled {
        &::before {
            content: "";
            display: block;
            position: absolute;
            left: -10px;
            top: 0;
            bottom: 11px;
            width: 10px;
            box-shadow: 5px 0 2px -3px #e5e9ef;
            z-index: 899;
        }
    }

    &.is-scrollable {
        &::after {
            content: "";
            display: block;
            position: absolute;
            right: -10px;
            top: 0;
            bottom: 11px;
            width: 10px;
            box-shadow: -5px 0px 2px -3px #e5e9ef;
            z-index: 1;
        }
    }
}

.scrollable {
    overflow-x: auto;
    min-height: 0.01%;
    width: 100%;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
}

table {
    width: 100%;
    border-collapse: collapse;
    border-radius: 20px;
}

table thead {
    background-color: #fbfbfb;
}

table th {
    text-align: left;
    color: #000000;
    padding: 15px 8px 12px;
    min-width: 30px;

    &:first-child,
    &:last-child {
        padding-left: 25px;
        padding-right: 18px;
    }

    &::first-letter {
        text-transform: uppercase;
    }
}

table td {
    font-size: 15px;
    font-weight: 500;
    line-height: normal;
    text-align: left;
    color: #263238;
    padding: 8px;
    white-space: nowrap;

    &:first-child,
    &:last-child {
        padding-left: 25px;
        padding-right: 18px;
    }

    strong {
        font-weight: 700;
    }
}
table tbody tr:nth-child(2n) td {
    background: #fbfbfb;
}

.table-time-text {
    &:not(:last-child) {
        &::after {
            content: "|";
            margin: 0 6px;
            color: #263238;
        }
    }
}

.table-actions {
    display: flex;
    align-items: center;
    gap: 11px;
    &__img {
        width: 20px;
        height: 20px;
    }
    span {
        cursor: pointer;
    }
}

.modal-add-keyword {
    padding: 24px 0 148px;
    &__line {
    }

    &__label {
        display: block;
        font-weight: 700;
        line-height: normal;
        color: #000;
        &:not(:last-child) {
            margin-bottom: 17px;
        }
    }

    &__select {
    }
}

.modal-add-keyword-footer {
    display: flex;
    align-items: center;
    gap: 48px;

    &__btn {
        width: 50%;
        &_close {
        }
    }
}
.modal-keyword {
  margin-top: 15px;
}
.keyword-input {
  background-color: white;
  width: 100%;
  padding-left: 14px;
  min-height: 40px;
}
.keyword-input:focus-visible  {
  outline: 1px solid #6fda44;
  border-radius: 3px;
}
</style>
